import type { EpicLeaderboardSort } from "../types/epicLeaderboard";

// URL slug -> full epic name (the API wants the exact name). Only epics that
// qualify for the small-group leaderboard are listed.
export const EPIC_SLUGS: Record<string, string> = {
  skd: "Sea King's Dominion",
  titans: "Titans' Keep",
  terra: "The Cracks of Terra"
};

export const DEFAULT_EPIC_SLUG = "skd";

export const RANGE_OPTIONS = [
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "year", label: "This year" },
  { value: "all", label: "All time" }
] as const;

export type RangeOption = (typeof RANGE_OPTIONS)[number]["value"];

export const DEFAULT_RANGE: RangeOption = "all";

export const SORT_OPTIONS: { value: EpicLeaderboardSort; label: string }[] = [
  { value: "fastest", label: "Fastest time" },
  { value: "average", label: "Average time" },
  { value: "runs", label: "Most runs" }
];

export const DEFAULT_SORT: EpicLeaderboardSort = "fastest";

// Mirrors the API defaults so the min-runs select can show the effective
// value when the URL doesn't carry one.
export const defaultMinRunsFor = (sort: EpicLeaderboardSort): number =>
  sort === "average" ? 3 : 1;

export const MIN_RUNS_OPTIONS = [1, 2, 3, 5, 10, 20];
